import { useTranslation } from 'react-i18next';

import type { ConfirmationDialogContainerProps } from '@/components/dialogs/elements.confirmation-dialog';
import {
  ConfirmationDialogActionCancelButton,
  ConfirmationDialogActionProceedButton,
  ConfirmationDialogActions,
  ConfirmationDialogContainer,
  ConfirmationDialogHeader,
} from '@/components/dialogs/elements.confirmation-dialog';

// ----------------------------------------------------------------------

export type ConfirmationDeleteDialogProps = Omit<ConfirmationDialogContainerProps, 'subject'> & {
  isLoading?: boolean;
  onProceed: () => void;
  instance?: string;
};

// ----------------------------------------------------------------------

export const ConfirmationDeleteDialog = (props: ConfirmationDeleteDialogProps) => {
  const {
    isLoading,
    title = 'Вы уверены что хотите удалить?',
    onClose,
    onProceed,
    children,
    instance = '',
    ...restOfDialogProps
  } = props;
  const { t } = useTranslation('confirmation-dialog-elements');

  return (
    <ConfirmationDialogContainer subject="delete" onClose={onClose} {...restOfDialogProps}>
      <ConfirmationDialogHeader>{title}</ConfirmationDialogHeader>

      {children}

      <ConfirmationDialogActions>
        <ConfirmationDialogActionCancelButton onClick={onClose} />
        <ConfirmationDialogActionProceedButton
          autoFocus
          loading={isLoading}
          onClick={onProceed}
          data-testid={`${instance}-confirmation-delete-dialog-proceed-btn`}
        >
          {t('confirmation-delete-dialog.actions.delete')}
        </ConfirmationDialogActionProceedButton>
      </ConfirmationDialogActions>
    </ConfirmationDialogContainer>
  );
};
